import React from "react";
import { HomeHeader } from "./components/HomeHeader";
import { HomeFooter } from "./components/HomeFooter";

export function HomeUIRootPages({ children }) {
  return (
    <div className="home-container">
      <HomeHeader />
      {children}
      <HomeFooter />
    </div>
  );
}
